'use client';

import { useEffect, useState } from 'react';

function useStickyNavigation(threshold = 100) {
    const [showNavigation, setShowNavigation] = useState<boolean>(true);
    const [lastScrollY, setLastScrollY] = useState<number>(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            // Check the difference in scroll position to exceed the threshold before toggling the header visibility
            if (Math.abs(currentScrollY - lastScrollY) > threshold) {
                if (currentScrollY > lastScrollY) {
                    setShowNavigation(false); // scrolling down
                } else {
                    setShowNavigation(true); // scrolling up
                }
                setLastScrollY(currentScrollY);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [lastScrollY, threshold]);

    return showNavigation;
}

export default useStickyNavigation;
